import api from "./client";

export const tenantLogin = (email, password) =>
  api.post("/api/tenant/auth/login", { email, password });

export const tenantRefresh = (refresh_token) =>
  api.post("/api/tenant/auth/refresh", { refresh_token });

export const getCurrentUser = () =>
  api.get("/api/tenant/auth/me");
